import Image from "next/image";
import CountUp from "react-countup";
import styles from './styles.module.scss';

const ProductContainer = ({ items }) => {
    const subtotalAmount = items.reduce((sum, item) => sum + parseFloat(item.subtotal), 0);
    const taxAmount = items.reduce((sum, item) => sum + parseFloat(item.taxesApplied), 0);
    const totalAmount = items.reduce((sum, item) => sum + parseFloat(item.total), 0);
  
    return (
      <div className={styles.productContainer}>
        <h2>Items Ordered</h2>
        {items.map((item, index) => (
          <div key={index} className={styles.productItem}>
            <Image
              src={item.image}
              alt={item.name}
              width={75}
              height={75}
              className={styles.productImage}
            />
            <div className={styles.productDetails}>
  
              <section>
                <h1>{item.name}</h1>
                <h2>${item.price.toFixed(2)} / ea</h2>
                <h3>Subtotal: <b>${item.subtotal}</b></h3>
              </section>
  
              <section>
                <div>
                  <h1>{item.quantity}</h1>
                  <h2>Quantity</h2>
                </div>
              </section>
  
            </div>
  
          </div>
        ))}
        <div className={styles.totalAmount}>
          <div>
            <h3>Subtotal:</h3>
            <p><CountUp prefix="$" start={0} end={subtotalAmount} decimals={2} duration={1} separator="," /></p>
          </div>
          <div>
            <h3>Tax:</h3>
            <p>{taxAmount === 0.00 ? 'No Tax' : <CountUp prefix="$" start={0} end={taxAmount} decimals={2} duration={1} separator="," />}</p>
          </div>
          <div>
            <h3>Total:</h3>
            <p><CountUp prefix="$" start={0} end={totalAmount} decimals={2} duration={1} separator="," /></p>
          </div>
        </div>
      </div>
    );
  };

export default ProductContainer